import * as React from 'react';
import Home from "../Pages/Home/Home"
import Breeding from "../Pages/Breeding/Breeding"
import Whitepaper from "../Pages/Whitepaper"
import PrivacyPolicy from "../Pages/PrivacyPolicy"
import Quests from "../Pages/Quests"
import Mint from "../Pages/Mint/WLMint"
import PublicMint from "../Pages/PublicMint/PublicMint"
import Gallery from "../Pages/Gallery"
import DragonDetails from "../Pages/Dragon/Details"
import { GetPublicMintRes } from '../../commands/mint/getPublicMint';
import { GetMintRes } from '../../commands/mint/getMint';
import TermsAndConditions from "../Pages/TermsAndConditions"
import Ranking from '../Pages/Ranking';
import { IDragon } from "../../helpers/interfaces/dragon";
import { IIdentity } from './Main';
import Profile from '../Pages/Profile';

//
interface IMainContentProps {
    page: string;
    socialUrls: any[]
    quests: any,
    updateQuests: Function,
    celebrateQuests: boolean,
    myDragons: IDragon[],
    addressDragons: IDragon[],
    reloadMyDragons: Function,
    //FIXME: Rename
    userWhitelistData?: GetMintRes | undefined,
    loadUserWhitelistInfData: Function,
    //FIXME: Rename
    publicData?: GetPublicMintRes,
    loadUserPublicInfoData: Function,
    reloadDragonsInProg: boolean,
    dragon: IDragon | undefined,
    user: IIdentity | null,
    setUserTwitter: Function
}

//FIXME: NextJs does not work like this 
export default function MainContent(props: IMainContentProps) {

    return (
        <>
            {props.page === 'home' && <Home socialUrls={props.socialUrls} updateQuests={props.updateQuests} />}
            {props.page === 'breeding' && <Breeding />}
            {props.page === 'whitepaper' && <Whitepaper />}
            {props.page === 'privacy_policy' && <PrivacyPolicy />}
            {props.page === 'termsAndConditions' && <TermsAndConditions />}
            {props.page === 'ranking' && <Ranking dragons={props.myDragons} reloadDragons={props.reloadMyDragons} />}

            {props.page === 'profile' && <Profile/>}


            {props.page === 'quests' &&
                <Quests
                    quests={props.quests}
                    updateQuests={props.updateQuests}
                    celebrateQuests={props.celebrateQuests}
                    setUserTwitter={props.setUserTwitter}
                />}

            {props.page === 'my_gallery' &&
                <Gallery
                    mode="my_gallery"
                    dragons={props.myDragons}
                    reloadDragons={props.reloadMyDragons}
                    reloadDragonsInProg={props.reloadDragonsInProg}
                    user={props.user}
                    updateQuests={props.updateQuests}
                    setUserTwitter={props.setUserTwitter}
                />}

            {props.page === 'gallery' &&
                <Gallery
                    mode="gallery"
                    dragons={props.addressDragons}
                    reloadDragonsInProg={props.reloadDragonsInProg}
                />}

            {props.page === 'nft_details' && <DragonDetails dragon={props.dragon} />}
        </>
    );
}
